import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import axios from '../../store/axios-secure'
import { FaTrashAlt, FaEdit, FaSave, FaTimes } from 'react-icons/fa'
import Loader from '../Common/Loader'

const Schedule = ({
    clientId,
    onClose,
    currAutomatedMessages,
    setCurrAutomatedMessages,
    onSave,
    currentChat,
}) => {
    const [message, setMessage] = useState('')
    const [frequency, setFrequency] = useState('daily')
    const [weekDay, setWeekDay] = useState('Monday')
    const [monthDay, setMonthDay] = useState(1)
    const [time, setTime] = useState('12:00')
    const [deleteLoadingIdx, setDeleteLoadingIdx] = useState(null)
    const dummyArray = [
        `Hi {name}, good morning! what are your plans for the day?`,
        `Hi {name}, good evening!
Workout done? (Y/N)
Food tracked? (Y/N)
Steps done? (Y/N)
Weight tracked? (Y/N)
Water tracked? (Y/N)`,
    ]
    const [msgTemplates, setMsgTemplates] = useState([])
    const [isSlashClicked, setIsSlashClicked] = useState(false)
    const [msgTemplatesLoader, setMsgTemplatesLoader] = useState(false)
    const [templateToDelete, setTemplateToDelete] = useState(null)
    const [templateToSave, setTemplateToSave] = useState(null)
    const [templateToEdit, setTemplateToEdit] = useState(null)
    const [addTemplateClicked, setAddTemplateClicked] = useState(false) // only one template at a time
    const [editedContent, setEditedContent] = useState(`Hi {name},`)
    const [checkInTemplate, setCheckInTemplate] = useState(null)
    const [editCheckIn, setEditCheckIn] = useState(null)
    const [saveCheckIn, setSaveCheckIn] = useState(null) //to maintain loader

    // const [hour, setHour] = useState(8);
    // const FrequencyOptions = ['Hourly', 'Daily', 'Weekly', 'Monthly'];
    const weekDaysOptions = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ]
    const dayNumberMapping = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
    }
    const containerRef = useRef(null)
    useEffect(() => {
        // Scroll to bottom when component mounts or msgTemplates change
        scrollToBottom()
    }, [msgTemplates, isSlashClicked])
    const scrollToBottom = () => {
        if (containerRef.current) {
            containerRef.current.scrollTop =
                containerRef.current.scrollHeight -
                containerRef.current.clientHeight
        }
    }
    const monthDaysOptions = Array.from({ length: 31 }, (_, index) => index + 1)
    // const hoursOptions = ['one', 'two', 'three', 'four', 'six', 'eight', 'twelve'];
    // const hoursOptions = [1, 2, 3, 4, 6, 8, 12]
    const handleSave = async () => {
        try {
            let date = new Date()
            const wDay = dayNumberMapping[weekDay]
            // Convert local time to UTC
            console.log('time:', time)
            const localTime = new Date(`${date.toDateString()} ${time}`)
            console.log('localTime:', localTime)

            // Use toISOString to ensure proper UTC conversion
            const formattedUtcTime = localTime.toISOString().slice(11, 16) // Extract HH:mm part
            console.log('formattedUtcTime:', formattedUtcTime)

            const response = await axios.post(`chat/setAutomatedMessage`, {
                clientId,
                message,
                frequency,
                weekDay: wDay,
                monthDay,
                time: formattedUtcTime,
                date,
            })

            const newAutomatedMessage = response?.data?.automatedMessage
            if (newAutomatedMessage) {
                setCurrAutomatedMessages([
                    newAutomatedMessage,
                    ...currAutomatedMessages,
                ])
                setMessage('')
            }
            if (response.data?.alreadyAutomatedMessage) {
                alert(response.data.message)
            }
        } catch (err) {
            console.log('error while saving the automated Message  ', err)
        }
    }
    const handleMsgDelete = async (msg, index) => {
        try {
            setDeleteLoadingIdx(index)
            let msgId = msg._id
            await axios.post(`chat/deleteAutomatedMessage`, {
                msgId,
            })
            const updatedMessages = currAutomatedMessages.filter(
                (message) => message._id !== msg._id,
            )
            setCurrAutomatedMessages(updatedMessages)
            setDeleteLoadingIdx(null)
        } catch (err) {
            console.log('error while deleting the automated Message  ', err)
            setDeleteLoadingIdx(null)
        }
    }
    const fetchMsgTemplates = async () => {
        try {
            setMsgTemplatesLoader(true)
            setIsSlashClicked(true)
            const response = await axios.get('/chat/autoMsgTemplates')
            let autoMessagesTemplates = response?.data?.automatedMsgTemplates

            if (
                JSON.stringify(msgTemplates) !==
                JSON.stringify(autoMessagesTemplates?.msgTemplates)
            ) {
                console.log(
                    'inside comparision.......',
                    msgTemplates,
                    autoMessagesTemplates?.msgTemplates,
                )
                setMsgTemplates(autoMessagesTemplates?.msgTemplates)
            }
            console.log(
                'autoMessagesTemplates?.checkInMessage......',
                autoMessagesTemplates?.checkInMessage,
            )
            setCheckInTemplate(autoMessagesTemplates?.checkInMessage)
            setMsgTemplatesLoader(false)
            // setMsgTemplates(dummyArray)
        } catch (err) {
            console.log(
                'error while fetching automatedMessages templates ',
                err,
            )
        }
    }
    const removeTemplate = async (template) => {
        try {
            //if template is not there in backend
            if (template?.isTemp) {
                setMsgTemplates((prevTemplates) =>
                    prevTemplates.filter((temp) => temp._id !== template._id),
                )
                setAddTemplateClicked(false)
                setEditedContent(`Hi {name},`)
                return
            }
            setTemplateToEdit(null)
        } catch (error) {
            console.log(error)
        }
    }
    const deleteTemplate = async (template) => {
        try {
            setTemplateToDelete(template)

            const response = await axios.delete(
                `chat/deleteMsgTemplate?templateId=${template?._id.toString()}`,
            )

            if (response.data.code == 1) {
                const updatedmsgTemplates = msgTemplates.filter(
                    (temp) => temp._id !== template?._id,
                )
                setMsgTemplates(updatedmsgTemplates)
                setTemplateToDelete(null)
            }
        } catch (error) {
            console.log(error)
        }
    }
    const saveTemplate = async (template) => {
        try {
            setTemplateToSave(template)
            if (template.content.trim() == '') {
                setTemplateToSave(null)
                return
            }
            //if template is not there in backend
            let response = null
            if (template?.isTemp) {
                response = await axios.post(`chat/addMsgTemplate`, {
                    content: editedContent,
                })
            } else {
                response = await axios.put(`chat/updateMsgTemplate`, {
                    content: editedContent,
                    templateId: template?._id,
                })
            }
            setAddTemplateClicked(false)
            setTemplateToSave(null)
            setTemplateToEdit(null)
            setEditedContent(`Hi {name},`)
            if (response && response.data.code == 1) {
                console.log(
                    '...............',
                    response.data.automatedMsgTemplates?.msgTemplates,
                )
                setMsgTemplates(
                    response.data.automatedMsgTemplates?.msgTemplates,
                )
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleTextareaKeyDown = async (e) => {
        if (e.key === '/') {
            e.preventDefault()
            if (isSlashClicked) {
                // setMsgTemplates([])
                setIsSlashClicked(false)
            } else {
                fetchMsgTemplates()
            }
        }
    }
    // const handleTemplateClick = (template) => {
    //     let modifiedTemplate = template.replace('{name}', currentChat?.userName.split(' ')[0]);
    //     setMessage((prevMsg) => prevMsg + modifiedTemplate);
    //     setMsgTemplates([]);
    // };
    const handleTemplateClick = (template, idx) => {
        console.log('clicked............')
        if (currentChat) {
            setMessage(
                (prevMsg) =>
                    prevMsg +
                    template.content.replace(
                        '{name}',
                        currentChat.userName.split(' ')[0],
                    ),
            )
            // setMsgTemplates([])
            setIsSlashClicked(false)
            setAddTemplateClicked(false)
        }
    }

    const addTemplate = () => {
        if (addTemplateClicked) {
            return
        }
        setAddTemplateClicked(true)
        let id = Math.random()
        let temp = { _id: id, content: 'hii {Name},', isTemp: true }
        setMsgTemplates((prevTemplates) => [...prevTemplates, temp])
    }

    const updateCheckInTemplate = async (checkIn) => {
        try {
            setSaveCheckIn(checkIn)
            if (checkIn.text.trim() == '') {
                return
            }

            const response = await axios.put(`chat/updateCheckInTemplate`, {
                text: checkIn.text,
                afterHours: checkIn.afterHours,
            })
            setEditCheckIn(null)
            setSaveCheckIn(null) //to maintin loader
            if (response.data.code == 1) {
                setCheckInTemplate(
                    response.data.automatedMsgTemplates?.checkInMessage,
                )
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <ScheduleContainer>
            <textarea
                placeholder={
                    !isSlashClicked
                        ? 'Type a message or type  /  to set templates...'
                        : 'Type  /  to go back'
                }
                style={{ height: '80px', maxHeight: '80px' }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleTextareaKeyDown}
            />
            {msgTemplatesLoader && msgTemplates.length < 1 && (
                <div style={{ marginLeft: '50%' }}>
                    <Loader />
                </div>
            )}
            {isSlashClicked && msgTemplates?.length > 0 && (
                <div
                    className="template-container"
                    style={{
                        color: 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#1f2731',
                        gap: '0px',
                        // position: 'fixed',
                        // marginTop: '95px',

                        maxHeight: '45vh',
                        overflowY: 'auto', // 'auto' to display scrollbar when needed
                    }}
                    ref={containerRef} // Reference to the container element
                >
                    {msgTemplates.map((template, index) => (
                        <div
                            key={index}
                            className="template-item"
                            style={{
                                backgroundColor: '#1f1f1f',
                                margin: '5px',
                                padding: '5px',
                                cursor: 'pointer',
                            }}
                            onClick={() => handleTemplateClick(template, index)}
                        >
                            {(addTemplateClicked &&
                                template?.isTemp === true) ||
                            (templateToEdit &&
                                templateToEdit._id == template._id) ? (
                                <>
                                    <textarea
                                        // rows={1}
                                        // className="email-box"
                                        style={{
                                            height: '70px',
                                            maxHeight: '70px',
                                        }}
                                        placeholder="write your msg template"
                                        value={editedContent}
                                        onClick={(e) => e.stopPropagation()} // Stop propagation for textarea
                                        onChange={(event) => {
                                            setEditedContent(event.target.value)
                                        }}
                                    />
                                    {templateToSave &&
                                    templateToSave._id == template._id ? (
                                        <div>
                                            <Loader />
                                        </div>
                                    ) : (
                                        <FaSave
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                saveTemplate(template)
                                            }}
                                        />
                                    )}

                                    <FaTimes
                                        onClick={(e) => {
                                            e.stopPropagation() // Stop propagation for FaTimes
                                            removeTemplate(template)
                                        }}
                                    />
                                </>
                            ) : (
                                <>
                                    <span
                                        style={{
                                            maxWidth: '90%',
                                            overflowWrap: 'break-word',
                                        }}
                                    >
                                        {template?.content}
                                    </span>
                                    <span>
                                        <FaEdit
                                            style={{
                                                fontSize: '11px',
                                                marginLeft: '5px',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setTemplateToEdit(template)
                                                setEditedContent(
                                                    template.content,
                                                )
                                            }}
                                        />

                                        {templateToDelete &&
                                        templateToDelete._id == template._id ? (
                                            <div>
                                                <Loader />
                                            </div>
                                        ) : (
                                            <FaTrashAlt
                                                style={{
                                                    fontSize: '11px',
                                                    marginLeft: '5px',
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    deleteTemplate(template)
                                                }}
                                            />
                                        )}
                                    </span>
                                </>
                            )}
                        </div>
                    ))}
                    <div style={{ marginLeft: '35%' }}>
                        <button
                            style={{
                                padding: '0px',
                                border: '1px solid',
                                marginTop: '7px',
                            }}
                            onClick={() => {
                                addTemplate()
                            }}
                        >
                            +Add
                        </button>
                    </div>
                </div>
            )}
            {isSlashClicked && checkInTemplate && (
                <div
                    className="template-container"
                    style={{
                        color: 'white',
                        backgroundColor: '#1f2731',
                        gap: '10px',
                        marginLeft: '3px',
                        paddingLeft: '2px',
                    }}
                >
                    {editCheckIn ? (
                        <>
                            <textarea
                                style={{
                                    height: '70px',
                                    minHeight: '70px',
                                    backgroundColor: '#1f1f1f',
                                }}
                                value={editCheckIn.text}
                                onClick={(e) => e.stopPropagation()} // Stop propagation for textarea
                                onChange={(e) => {
                                    setEditCheckIn({
                                        ...editCheckIn,
                                        text: e.target.value,
                                    })
                                }}
                            />
                            <div style={{ marginTop: '10px' }}>
                                {/* <label>Select After Hours:</label> */}
                                <select
                                    style={{
                                        height: '30px',
                                        backgroundColor: '#1f1f1f',
                                        marginTop: '14px',
                                    }}
                                    value={editCheckIn.afterHours}
                                    onChange={(e) => {
                                        setEditCheckIn({
                                            ...editCheckIn,
                                            afterHours: e.target.value,
                                        })
                                    }}
                                >
                                    <option value="24">24</option>
                                    <option value="48">48</option>
                                    <option value="72">72</option>
                                </select>
                            </div>
                            {saveCheckIn ? (
                                <div>
                                    <Loader />
                                </div>
                            ) : (
                                <FaSave
                                    style={{ margin: '2px' }}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        updateCheckInTemplate(editCheckIn)
                                    }}
                                />
                            )}

                            <FaTimes
                                style={{ margin: '2px' }}
                                onClick={(e) => {
                                    e.stopPropagation() // Stop propagation for FaTimes
                                    setEditCheckIn(null)
                                }}
                            />
                        </>
                    ) : (
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <span
                                style={{
                                    maxWidth: '100%',
                                    overflowWrap: 'break-word',
                                    marginTop: '3px',
                                }}
                            >
                                {checkInTemplate?.text}

                                <span
                                    style={{
                                        marginLeft: '10px',
                                        padding: '3px',
                                        backgroundColor: '#101317',
                                    }}
                                >
                                    {checkInTemplate?.afterHours}
                                </span>
                            </span>
                            {/* <span>
                                <FaEdit
                                    style={{
                                        fontSize: '11px',
                                        marginLeft: '5px',
                                    }}
                                    onClick={() => {
                                        // addTemplate()
                                        setEditCheckIn(checkInTemplate);
                                    }}
                                />

                            </span> */}
                            <div style={{ marginLeft: '35%' }}>
                                <button
                                    style={{
                                        padding: '0px',
                                        border: '1px solid',
                                        // marginTop: '5px',
                                        width: 'auto',
                                    }}
                                    onClick={() => {
                                        setEditCheckIn(checkInTemplate)
                                    }}
                                >
                                    Edit checkIn
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
            {!isSlashClicked && (
                <>
                    <div style={{ flexWrap: 'wrap' }}>
                        <div>
                            <label>Freq:</label>
                            <select
                                value={frequency}
                                onChange={(e) => setFrequency(e.target.value)}
                            >
                                {/* {FrequencyOptions.map((frequency, index) => {
                        <option key={index} value={frequency}>{frequency}</option>
                    })} */}
                                {/* <option value="hourly">Hourly</option> */}
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                            </select>
                        </div>
                        {frequency === 'weekly' && (
                            <div>
                                <label>Day:</label>
                                <select
                                    value={weekDay}
                                    onChange={(e) => setWeekDay(e.target.value)}
                                >
                                    {weekDaysOptions.map(
                                        (weekOption, index) => (
                                            <option
                                                key={index}
                                                value={weekOption}
                                            >
                                                {weekOption}
                                            </option>
                                        ),
                                    )}
                                </select>
                            </div>
                        )}
                        {frequency === 'monthly' && (
                            <div>
                                <label>Day:</label>
                                <select
                                    value={monthDay}
                                    onChange={(e) =>
                                        setMonthDay(e.target.value)
                                    }
                                >
                                    {monthDaysOptions.map(
                                        (dayOption, index) => (
                                            <option
                                                key={index}
                                                value={dayOption}
                                            >
                                                {dayOption}
                                            </option>
                                        ),
                                    )}
                                </select>
                            </div>
                        )}
                        {/* {frequency === 'hourly' && (
                    <div>
                        <label>Hour:</label>
                        <select
                            value={hour}
                            onChange={(e) => setHour(e.target.value)}
                        >
                            {hoursOptions.map((hourOption, index) => (
                                <option key={index} value={hourOption}>
                                    {hourOption}
                                </option>
                            ))}
                        </select>
                    </div>
                )} */}
                        {frequency && (
                            <div>
                                <label>Time:</label>
                                <input
                                    type="time"
                                    value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                />
                            </div>
                        )}
                    </div>
                    <div
                        style={{
                            justifyContent: 'space-around',
                            marginTop: '10px',
                        }}
                    >
                        <button
                            onClick={handleSave}
                            disabled={message.trim() == '' || !frequency}
                        >
                            Save
                        </button>
                        <button onClick={onClose}>Cancel</button>
                    </div>
                    <div
                        className="scheduled-messages"
                        style={{ display: 'flex' }}
                    >
                        {currAutomatedMessages.map((msg, index) => {
                            // Convert UTC time to local time
                            const utcTime = new Date(
                                `1970-01-01T${msg.time}:00Z`,
                            )
                            const localTime = utcTime.toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false,
                            })

                            return (
                                <div
                                    style={{
                                        backgroundColor: '#1f2731',
                                        width: '98%',
                                        margin: '5px',
                                        padding: '3px',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <div
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '0px',
                                            marginBottom: '0px',
                                            width: '100%',
                                            whiteSpace: 'pre-line', //for activating \n
                                        }}
                                    >
                                        {msg.text}
                                        <span
                                            style={{
                                                fontSize: '10px',
                                                color: '#bbb5b5',
                                            }}
                                        >
                                            {msg.frequency === 'weekly' &&
                                                `Weekly  ${
                                                    weekDaysOptions[msg.weekDay]
                                                }  ${localTime}`}
                                            {msg.frequency === 'monthly' &&
                                                `Monthly  ${msg.monthDay}  ${localTime}`}
                                            {msg.frequency === 'daily' &&
                                                `Daily  ${localTime}`}
                                        </span>
                                    </div>
                                    {deleteLoadingIdx == index ? (
                                        <Loader />
                                    ) : (
                                        <FaTimes
                                            style={{
                                                fontSize: '13px',
                                                cursor: 'pointer',
                                                marginTop: '3px',
                                                color: '#a9a7a3bd',
                                            }}
                                            onClick={() =>
                                                handleMsgDelete(msg, index)
                                            }
                                        />
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </>
            )}
        </ScheduleContainer>
    )
}

const ScheduleContainer = styled.div`
  position: absolute;
//  top: 50%;
//  left: 50%;
//  transform: translate(-50%, -50%);
  padding: 10px;
  background-color: #101317;
//   border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 10002;
  display: flex;
  flex-direction: column;
  height:100%;
  width:100%;
  font-size:14px;

  textarea {
    margin-top:10px;
    margin-bottom: 15px;
    background-color: #1f2731;
    color:white;
    border: 1px solid #857c7c69;
    width: 100%;
    height: 100px;
    min-height: 80px;
  }
//   template-container{
//     background-color: white;
//     color: white;
//     /* position: fixed; */
//     display: flex;
//     flex-direction: column;
//     background-color: #1f2731;
//     gap: 0px;
//   }
//   template_item{
//     background-color: #1f1f1f;
//     margin: 5px;
//   }
  div {
   margin-bottom: 10px;
    display: flex;
    flexWrap: 'wrap';
    gap: 15px;
    // align-items: center;

    label {
      width: 40px;
      margin-top:0px;
     // text-align: right;
      color: white;
    }

    select{
        background-color: #1f2731;
        color: white;

    }
    input {
        // flex-grow: 1;
        color: white;
        background-color: #1f2731;
    }

  }
  .scheduled-messages{
    display: flex;
    color: white;
    flex-direction: column;
    border: 1px solid #857c7c69;
    overflow: hidden;
    overflow-y: auto;
    min-height: 130px;
    height: 350px;
    margin-top:20px;
    gap:0px;
  }

  button {
    width: 80px;
    background-color: #1f2731;
    color: white;
}
  }
`

export default Schedule
